// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"4516c7c0","153":"6417e790","307":"ff807ce6","365":"dc57fc7f","588":"4516c7c0","936":"ff807ce6","964":"eaf6db9f"}[chunkId] + ".css";
};